
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: {  },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        programId: {
            required: false,
            default: 0,
            type: Number
        },
        siteId: {
            required: false,
            default: 0,
            type: Number
        }
    },
    
    data: () => ({
        fetchedProgram: null,
        loading: false
    }),
    computed: {
        history() {
            return this.sortByDate(this.fetchedProgram.history)
        },
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        program() {
            return this.fetchedProgram.program
        }
    },
    methods: {
        daysSinceOrder(order) {
            var appointmentDate = new Date(order);
            this.isExpired(order)
            var today = new Date();
            const daysFromToday = Math.round((today - appointmentDate) / (24 * 60 * 60 * 1000));            
            switch (true) {
                case this.isExpired(order):
                    return 'Utgått'
                case (appointmentDate.getDate() == today):
                    return 'Idag'
                case daysFromToday >= 0: 
                    return Math.abs(daysFromToday) + ' dager siden';
            }
        },
        sortByDate(orderList) {
            return orderList.sort(function(a,b){
                return new Date(b.appointmentDate) - new Date(a.appointmentDate);
            });
        },
        isExpired(order) {
            var today = this.$moment()
            var expiration = this.$moment(order).add(this.fetchedProgram.program.bonusPointsDuration, 'M')
            return today.diff(expiration) > 0
        },
        getDate(appointmentDate) {
            return new Date(appointmentDate).toLocaleDateString("no-NO", { year: 'numeric', month: this.$vuetify.breakpoint.smAndDown ? 'numeric' : 'long', day: 'numeric' })
        },
        switchComponent(item) {
            if (this.layout == 'chain') {
                this.$router.replace({query: { title: 'ordredetaljer', siteId: item.siteId, orderId: item.appointmentIdBase64, type: 2}, params: {order: item}})
            } else {
                this.$router.push({name: 'PoengOrdredetaljer', params: {id: this.program.customerProgramId, orderId: item.appointmentIdBase64, siteId: item.siteId, order: item, type: 2}, query: {siteId: this.program.customer.siteId}})
            }
        }
    },
    async created() {
        this.loading = true 
        profileSvc = await ProfileSvc(this.$axios);
        this.fetchedProgram = await profileSvc.GetCustomerProgramById(this.bookingApi, this.layout == 'portal' ? this.$route.params.id : this.programId, this.$route.query.siteId ? this.$route.query.siteId : this.siteId)
        this.loading = false
    },
    beforeDestroy() {
        profileSvc = null
    }
}
